import { UserScopedVersionableStorageManager } from '@bridebook/toolbox/src/storage-managers/managers/user-scoped-versionable-storage-manager';
import { TSearchLocationInitialized } from '@bridebook/web/lib/search/types';

export const SearchLocationStorage =
  UserScopedVersionableStorageManager<TSearchLocationInitialized>({
    storageKey: 'state-search-searchLocation',
    version: '1.1',
  });
